import React from 'react';
import { GenericError } from 'components/generic-error/GenericError';

export const GenericErrorPage = () => <GenericError />;
